module.exports = __webpack_public_path__ + "img/suzhou_s.a0ab4f9.png";